export default __webpack_public_path__ + "static/media/clothing_shirt.172f1ef6.svg";